<div *ngIf="popupView" class="map-header">
  <h3 class="map-header-title">Mall map</h3>
  <app-button type="text" [icon]="modalCloseIcon" (click)="closeModal()"><span>Close Map</span></app-button>
</div>
<section id="mappedin-wrapper" *ngIf="mapsEnabled" class="shop-map">
  <div data-key="externalId" id="mappedin-map"></div>

  <link href="https://d1p5cqqchvbqmy.cloudfront.net/web2/release/mappedin-web.css" rel="stylesheet" />
  <script-hack id="mappedin" type="text/javascript"
    src="https://d1p5cqqchvbqmy.cloudfront.net/web2/release/mappedin-web.js"></script-hack>
</section>